module.exports = __webpack_public_path__ + "img/unitel.a11a3ce8.png";